export default "__VITE_PUBLIC_ASSET__53b9e92f__"